<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @submitReview="
        ({ freightDeductionCode }) => submitReview([freightDeductionCode])
      "
      @checkbox-change="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
        :check-count="checkCount"
        @submitReview="batchSubmitReview"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true, shipmentPayVisible: false, checkedRow: [] }
  },
  computed: {
    checkCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentFreightDeductionListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-freightScmDeduction-detail',
        params: { ...params, pageType },
        query,
      })
    },
    async batchSubmitReview() {
      if (!this.checkCount) return
      const listCode = this.checkedRow.map((item) => item.freightDeductionCode)
      this.submitReviewApi(listCode)
    },
    submitReview(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.submitReviewApi(listCode)
      })
    },
    async submitReviewApi(listCode) {
      this.loadingOpen()
      const res = await this.$api
        .shipmentFreightDeductionSubmitReviewApi({ listCode })
        .catch(() => this.loadingClose())
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (200 !== status) {
        this.$message.error(
          this.$l('INDEX.tips_submission_failed') || '提交失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.checkedRow = []
      this.$refs.main.clearCheckboxRows()
      this.reload()
    },
  },
}
</script>
